import { render, staticRenderFns } from "./PlanejamentoAcao.vue?vue&type=template&id=db9cdda0"
import script from "./PlanejamentoAcao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports